import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const ChartTitleStyled = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const ChartTitleHeader = styled.h2`
  max-width: 550px;
  overflow-wrap: break-word;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const ChartTitleDescription = styled.p`
  width: 550px;
  overflow-wrap: break-word;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;
